import { tv } from 'tailwind-variants';

const styles = tv({
  base: `
      grid
      list-inside
      list-disc
      gap-2
    `,
});

export default styles;
